import React, {useState, useEffect} from 'react';
import './style.css'

import QRCode from "react-qr-code";
import { useRefresh } from '../../../hooks/useRefresh';
import { getData } from '../../../helpers/indexedDbHelper';
import HappyScreen from '../../../screens/menu/weekend';
import { useTranslation } from 'react-i18next';
import translate from '../../../helpers/translate';

const Index = ({ showBack = true, showFooterBack = true, children, showLogo = true, showRedes = true, setScreen, setdishs }) => {
   const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const [showModal, setShowModal] = React.useState(false);

   const {change} = useRefresh();
  const [menus, setMenus] = useState([]);
  const [showListProduct, setShowListProduct] = useState(false);
  const [showHappy, setShowHappy] = useState(false);
   const [showModalPincode, setShowModalPincode] = React.useState(false);
  const [secret, setScret] = React.useState("");
  
   useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
           
            setMenus(data);
        });
   }, [change]);
  
  
  const validScret = () => {

    if (secret === '') {
      alert('Debe ingresar el pin')
    }

    if (secret === "2355") {
       window.location.reload();
    } else {
       alert('Code invalid')
    }
    
  }
  
   useEffect(() => {
              const handleVisibilityChange = () => {
              if (document.visibilityState === "hidden") {
                  console.log("La página ha perdido el foco (está oculta).");
                setShowListProduct(false);
                 setShowHappy(false);
      
              } else if (document.visibilityState === "visible") {
                  console.log("La página está en foco (visible).");
              }
              };
      
              document.addEventListener("visibilitychange", handleVisibilityChange);
      
              // Limpieza del evento al desmontar el componente
              return () => {
              document.removeEventListener("visibilitychange", handleVisibilityChange);
              };
   }, []);
  

    return (
      <div className='backgroundlayout' style={{
        flex: 1,
        backgroundSize: 'cover',
        width: '100%',
        height: '100vh',
        background: '#fbf0df',
         backgroundImage: `url(${require('./assets/fondo.png')})`,
            
              backgroundSize: '100% 100%',
         
      }}>
        <div>
          {/*<button onClick={()=>setOpenNav(!openNav)} style={{...styles.iconMenuMobile, ...iconMenu}}>
            <Menu />
          </button>*/}
          

          <div style={{display: 'flex'}}>
           




            <div className='contentChild' style={{
             
             
            }} >

                <div className='nav-menu-bar' style={{
                  marginTop: -4 ,
                  width: '100%',
                  position: 'relative'
                
                }}>
                  
                  {showLogo &&
                  <div style={{
                  background: '#000',
                  paddingTop: 20,
                  paddingBottom: 20,
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                    justifyContent: 'space-between',
                
                  }}>
                  
                
                  </div>
              }
              


            

                </div>
              {children}
              

               {showModalPincode &&
                <div style={{ position: 'absolute', top: 0, bottom: 0, left: 0, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#00000063', zIndex: 9999, flexDirection: 'column' }}>
                  
                  <div style={{ position: 'absolute',background: '#fff', width: 500, height: 300, borderRadius: 30, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: "column" }}>
                    <img
                        onClick={()=>setShowModalPincode(false)}
                      style={{
                        position: 'absolute',
                        top: -10,
                        
                                  width: 40,
                                    height: 40,
                                    marginInline: 10,
                                    objectFit: 'contain',
                                    position: 'absolute',
                                    right: -10,
                                    zIndex: 9999
                                
                              }}
                        src={require('./assets/close.png')}
                        alt="Logo"
                    /> 
                    <h4 style={{ color: '#F40000', fontSize: 40, fontWeight: 'bold', margin: 20 }}>PIN</h4>
                    <input type='number' style={{ width: 300, height: 40 }} onChange={(e) => {
                      setScret(e.target.value)
                    }} />
                    <br /><br />
                    
                    <div style={{display: 'flex', gap: 20}}>
                      <div onClick={() => setShowModalPincode(false)} style={{background: '#FF1616', width: 150, height: 50, justifyContent: 'center', alignItems: 'center', display: 'flex', borderRadius: 7}}>
                        <p style={{color: 'white', textTransform: 'uppercase', fontWeight: 'bold'}}>atras</p>
                      </div>
                      <div onClick={()=>validScret()} style={{ background: '#FF1616', width: 150, height: 50, justifyContent: 'center', alignItems: 'center', display: 'flex', borderRadius: 7 }}>
                        <p style={{color: 'white', textTransform: 'uppercase', fontWeight: 'bold'}}>Enviar</p>
                    </div>
                  </div>
                  </div>
                </div>
            }

              
              <img
                onClick={()=>setShowModalPincode(true)}
                        style={{
                          width: 25,
                            height: 25,
                            marginInline: 10,
                            objectFit: 'contain',
                            position: 'absolute',
                            bottom: -3,
                            right: 0,
                            zIndex: 9999
                        
                      }}
                src={require('./assets/pincode.png')}
                alt="Logo"
            /> 
            
            {showModal &&  <div onClick={()=>setShowModal(false)} style={{position: 'absolute', top: 0, bottom: 0, left: 0,width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#00000063', zIndex: 9999}}>
              <QRCode
              size={256}
              style={{ height: 400,  width: 400 }}
              value={showModal}
              viewBox={`0 0 256 256`}
            />
            </div>}
           
            </div>
             <div style={{width: '25%', background: '#fff',
                width: '25%',
                height: '100%',}}>
              

            

              <div style={{
               
               
                flexDirection: 'column',
                
                  justifyContent: 'center',
                alignItems: 'center',
                overflow: 'scroll',
                maxHeight: 990,
                overflowX: 'hidden',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                
                paddingBottom: 20,
                 backgroundImage: `url(${require('./assets/bk_nav.png')})`,
                
                
              }}    >


                {menus.map(item => {
                    return (
                      <div
                        
                        onClick={() => {

                          if (item.id == 507) {
                            setShowHappy(true);
                          } else {
                            setScreen('listproduct')
                           setdishs(item);
                          // setShowListProduct(true
                          // );
                          }
                          
                        }}
                        
                        style={{
                         
                       height: 60,
                        paddingInline: 5,
                          marginTop: 29,
                         
                        display: 'flex',
                        justifyContent: 'center',
                          alignItems: 'center',
                        paddingInline: 10,
                      }}  >

                        <div style={{
                          flex: 1,
                          backgroundColor: '#fdf5e6',
                          border: '4px solid #d4a017',
                          borderRadius: 12,
                          width: 110,
                          height: 50,
                          paddingInline: 10,
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          boxShadow: 'inset 0 0 0 2px #c8961e',
                        }}>
                          <p style={{
                            fontSize: 19,
                            color: '#2d5a3d',
                            textTransform: 'uppercase',
                            textAlign: 'center',
                            fontFamily: 'LondrinaSolidRegular',
                            margin: 0,
                          }}>
                            {langEng
                              ? item.name
                              : translate(i18n.language, item.language, item.name)}
                            
                            </p>
                        </div>
                        
                      </div>
                    );
                })}
                

              </div>

              
              
              
            </div>
          </div>

         
        </div>
{/* 
        {showListProduct && <ListProducts
                dishs={dishs}
                setShowListProduct={setShowListProduct}
        />} */}

        {showHappy && <HappyScreen
                setShowSpecials={setShowHappy}
            />}
        
      </div>
     
    );
  };

export default Index;